import React from 'react'
import {Icon, Paragraph, ParagraphProps} from 'common/components'
import {TransactionStatus} from 'types'
import {
  GIFT_SHOP_TRANSACTION_STATUS_COLORS,
  GIFT_SHOP_TRANSACTION_STATUS_ICONS,
} from 'consts'
import {useTranslation} from 'i18n'

export default function TransactionDetailStatus({
  status,
  showIcon = false,
  paragraphProps,
}: {
  status: TransactionStatus
  paragraphProps?: ParagraphProps
  showIcon?: boolean
}) {
  const {translate} = useTranslation()

  return (
    <div style={{display: 'flex', alignItems: 'center'}}>
      {showIcon && (
        <Icon
          type={GIFT_SHOP_TRANSACTION_STATUS_ICONS[status]}
          color={GIFT_SHOP_TRANSACTION_STATUS_COLORS[status]}
        />
      )}
      <Paragraph
        fontWeight="bold"
        color={GIFT_SHOP_TRANSACTION_STATUS_COLORS[status]}
        fontSize="m"
        {...paragraphProps}>
        {translate('giftShop:transactionStatus', {
          context: status,
        })}
      </Paragraph>
    </div>
  )
}
